import type { MouseEvent } from "react";

import { cx, styled } from "simplydo/react/styled";

import type { CheckboxSlotProps } from "./Checkbox.types";
import { useCheckboxContext } from "./CheckboxContext";

const ContentEl = styled.div`
  cursor: pointer;

  .is-disabled & {
    cursor: default;
  }
`;

const CheckboxContentComponent = (props: CheckboxSlotProps) => {
  const { children, className, style } = props;
  const { disabled, toggle } = useCheckboxContext();

  const handleClick = (event: MouseEvent) => {
    if (disabled) {
      return;
    }
    event.stopPropagation();
    toggle();
  };

  return (
    <ContentEl className={cx(className)} style={style} onClick={handleClick}>
      {children}
    </ContentEl>
  );
};

export const CheckboxContent = styled(CheckboxContentComponent)``;
CheckboxContent.displayName = "CheckboxContent";
